export const privacyPolicyMarkdown = `# Privacy Policy

Legal: Terms of Use · Privacy Policy · Subscription Terms · Do not sell personal data

**Effective as of: 25.06.2025**

## Important Privacy Information

When you access our website we may automatically collect technical data from your device, including:

- language settings
- IP address
- time zone
- device type and model
- device settings
- operating system
- Internet service provider
- mobile carrier
- hardware ID
- Facebook ID
- other unique identifiers (such as IDFA and AAID)
- cookies

We use this data to provide our services, analyze website usage, and measure ads.

For improving the website and serving ads, we may use third-party solutions, including providers such as Amazon, Amplitude, AppsFlyer, BigQuery, Crashlytics, Google, Firebase, Hotjar, Iterable, Meta, OpenAI, PayPal, Solid, Tableau, TikTok, Zendesk.

If you make a purchase or order a service, we may ask for your name and email. We may also process personal data included in your user content to provide access to the service.

## Privacy Policy

This policy explains what personal data is collected when you use:

- chatwithai.com

and related services and products.

By using the service, you confirm that:

1. you have read and agree to this Privacy Policy
2. you are over 16 years old (or have parental/guardian consent)

## Sections

1. Personal data controller
2. Categories of personal data we collect
3. For what purposes we process your personal data
4. Under what legal bases we process your personal data
5. With whom we share your personal data
6. How you can exercise your privacy rights
7. Age limitation
8. International data transfers
9. Changes to this privacy policy
10. U.S. states privacy notice
11. Data retention and security
12. How "Do not track" requests are handled
13. Contact us

---

Source: https://chatwithai.com/legal/privacy-policy
`;

export const subscriptionTermsMarkdown = `# Subscription Terms

Legal: Terms of Use · Privacy Policy · Subscription Terms · Do not sell personal data

**Last updated: 17.07.2023**

## Sections

1. Trial
2. Subscription
3. Products method
4. Cancellation
5. Changes
6. Refund rules

If you have questions about subscription terms, contact: **[email protected]**.

Please take a screenshot of these terms for your reference. This may help you control your subscriptions.

---

Source: https://chatwithai.com/legal/subscription-terms
`;

export const termsOfUseMarkdown = `# Terms and Conditions of Use

Legal: Terms of Use · Privacy Policy · Subscription Terms · Do not sell personal data

**Last updated: 17.07.2023**

## Important

The service may offer subscriptions that automatically renew.

To avoid being charged, you must cancel a subscription or trial at least 24 hours before the end of the trial or current subscription period.

If you are unsure how to cancel, see Subscription Terms.

## Sections

1. Acceptance of terms
2. Important disclaimers
3. Account registration
4. Service
5. Intellectual property, user content
6. Payments and refunds
7. User representation and restrictions
8. Disclaimer of warranties
9. Limitation of liability
10. Indemnity
11. International use
12. Mandatory binding arbitration and class action waiver
13. Governing law
14. Miscellaneous provisions
15. Contact

---

Source: https://chatwithai.com/legal/terms-of-use
`;
